
export default function Features() {
  const features = [
    {
      icon: 'ri-team-line',
      title: 'Strong Industry Relationships',
      description: 'Building long-term partnerships with dealers and buyers based on trust and mutual success.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Efficient Operations',
      description: 'Simplifying the wholesale process with clear systems and reliable execution every time.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Market Expertise',
      description: 'Leveraging deep automotive knowledge to identify profitable opportunities in any market.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity & Trust',
      description: 'Operating with transparency and accountability in every transaction we handle.'
    }
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Choose Edgeway Auto
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We pride ourselves on delivering exceptional value through our core strengths and commitments
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start space-x-6">
              <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {feature.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <p className="text-2xl font-semibold text-gray-900 mb-8">
            Driven by results and relationships, Edgeway Auto is more than a wholesale company—
            <br />
            we're your strategic partner in navigating the automotive marketplace.
          </p>
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
}
